import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Button, PRIORITY } from 'wix-ui-tpa/Button';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';

import { classes, st } from './CTAGroup.st.css';
import { useModal } from '../../../../../contexts/modals/hooks';
import { DiscardChangesModal } from '../../modals';
import { DataHook } from '../../../../../constants/DataHook';
import settingsParams from '../../../settingsParams';
import { Field } from '../../../../../types';

export const CTAGroup: FC = () => {
  const { isMobile } = useEnvironment();
  const { showModal } = useModal();
  const { resetForm, dirty } = useFormikContext<Field[]>();
  const settings = useSettings();

  return (
    <div className={st(classes.root, isMobile ? classes.mobile : undefined)}>
      <div className={classes.container}>
        <Button
          upgrade
          priority={PRIORITY.secondary}
          onClick={() =>
            showModal(DiscardChangesModal, { onConfirm: resetForm })
          }
          data-hook={DataHook.DiscardChangesButton}
          className={st(classes.discardButton, { disabled: !dirty })}
          disabled={!dirty}
        >
          {settings.get(settingsParams.discardButtonText)}
        </Button>

        <Button
          className={classes.saveButton}
          data-hook={DataHook.SaveAccountButton}
          type="submit"
          priority={PRIORITY.primary}
          disabled={!dirty}
          upgrade
        >
          {settings.get(settingsParams.saveButtonText)}
        </Button>
      </div>
    </div>
  );
};
